import React from 'react';
import { flexRender, Header, SortDirection } from '@tanstack/react-table';
import { arrowDown, arrowUp } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import {
  StyledHeader,
  StyledHeaderContainer,
  StyledHeaderTitle,
  StyledSortIcon,
} from '../../AllieDataGrid.styles';
import { AllieText } from '../../../Text';
import { Justify } from '../../AllieDataGrid.types';
import { AllieChevronDown, AllieChevronUp } from '../../../../styling/icons';

const SORT_ICONS: Record<SortDirection, any> = {
  asc: arrowDown,
  desc: arrowUp,
};

export type DataGridHeaderProps = {
  header: Header<unknown, unknown>;
  headerStyle?: React.CSSProperties;
};

type DataGridHeaderSortIconProps = {
  sort: SortDirection;
};
const DataGridHeaderSortIcon: React.FC<DataGridHeaderSortIconProps> = ({ sort }) => {
  const sortChild = SORT_ICONS[sort] || null;
  if (sortChild) return <IonIcon icon={sortChild} />;

  return null;
};

interface TanStackMeta {
  justify: Justify;
  suffix?: React.ReactNode;
}

export const DataGridHeader: React.FC<DataGridHeaderProps> = ({ header, headerStyle }) => {
  const sortDirection = header.column.getIsSorted() as SortDirection;
  const isSortable = header.column.getCanSort();
  const meta = header.column.columnDef?.meta as TanStackMeta;
  const suffix = meta?.suffix;

  return (
    <StyledHeader
      key={header.id}
      colSpan={header.colSpan}
      style={{
        ...headerStyle,
        width: header.getSize(),
        cursor: isSortable ? 'pointer' : 'default',
      }}
    >
      {!header.isPlaceholder && (
        <div onClick={isSortable ? header.column.getToggleSortingHandler() : undefined}>
          <StyledHeaderContainer justify={(header.column.columnDef?.meta as TanStackMeta)?.justify}>
            <StyledHeaderTitle>
              <AllieText color="neutral-60" style={{ lineHeight: '24px' }}>
                {flexRender(header.column.columnDef.header, header.getContext())}
              </AllieText>
            </StyledHeaderTitle>
            {suffix}
            {isSortable && (
              <StyledSortIcon
                style={{
                  opacity: !sortDirection ? 0.5 : 1,
                  display: 'flex',
                  flexDirection: 'column',
                  marginLeft: 'var(--allie-spacing-md)',
                }}
              >
                <AllieChevronUp
                  display="flex"
                  style={{ opacity: sortDirection === 'asc' ? 1 : 0.3 }}
                />
                <AllieChevronDown
                  display="flex"
                  style={{ opacity: sortDirection === 'desc' ? 1 : 0.3 }}
                />
              </StyledSortIcon>
            )}
          </StyledHeaderContainer>
        </div>
      )}
    </StyledHeader>
  );
};
